import { useEffect, useState } from 'react';

import log from 'loglevel';

import { useFetchRecurrenceInboxEntries } from './useFetchRecurrenceInboxEntries';
import { useInboxEntriesStore } from '../../store';

const RECURRENCE_COUNT_FETCH_LIMIT = 500;

interface RecurrenceCountByGroup {
  taskGroupId: string;
  count: number;
}

export function useDoBoxRecurrenceCount(enabled: boolean): number | null {
  const activeTaskGroupId = useInboxEntriesStore(
    (state) => state.taskManager.activeTaskGroup.taskGroupId,
  );
  const [countByGroup, setCountByGroup] =
    useState<RecurrenceCountByGroup | null>(null);
  const { fetchRecurrenceInboxEntries } = useFetchRecurrenceInboxEntries();

  useEffect(() => {
    if (!enabled || !activeTaskGroupId) {
      return;
    }

    let cancelled = false;

    const fetchCount = async () => {
      try {
        const result = await fetchRecurrenceInboxEntries({
          limit: RECURRENCE_COUNT_FETCH_LIMIT,
        });
        if (cancelled) {
          return;
        }
        setCountByGroup({
          taskGroupId: activeTaskGroupId,
          count: result?.recurrenceInboxEntries.length ?? 0,
        });
      } catch (error) {
        if (!cancelled) {
          log.error('useDoBoxRecurrenceCount fetch failed:', error);
        }
      }
    };

    fetchCount();

    return () => {
      cancelled = true;
    };
  }, [enabled, activeTaskGroupId, fetchRecurrenceInboxEntries]);

  return countByGroup?.taskGroupId === activeTaskGroupId
    ? countByGroup.count
    : null;
}
